// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/barcode/barcode.less
// module id = 2813
// module chunks = 0 1